import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import DynamicsService, {
  DynamicsVerifyIntegrationResult,
} from './DynamicsService';
import { useCallback, useState } from 'react';

const useVerifyDynamicsIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<DynamicsVerifyIntegrationResult>>(defaultInitialState);

  const verifyDynamicsIntegration = useCallback(async () => {
    setState({
      error: null,
      status: AsyncStatus.pending,
      data: null,
      isLoading: true,
    });
    const resultPromise = DynamicsService.verifyDynamicsIntegration();
    resultPromise.then(
      (result) => {
        setState({
          error: null,
          status: AsyncStatus.resolved,
          data: result,
          isLoading: false,
        });
      },
      (error) => {
        setState({
          error: error,
          status: AsyncStatus.rejected,
          data: null,
          isLoading: false,
        });
      },
    );
  }, [setState]);

  return {
    verifyDynamicsIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data.isSuccess : false),
    isSuccess: status === AsyncStatus.resolved && data?.data.isSuccess,
    data,
  };
};

export default useVerifyDynamicsIntegration;
